<div class="menu-manager">
    <p-tabView>
        <p-tabPanel header="Main Menu">
            <app-admin-menu-page [settingType]="'MENU'"></app-admin-menu-page>
        </p-tabPanel>
        <p-tabPanel header="Top Menu">
            <app-admin-menu-page [settingType]="'TOP_MENU'"></app-admin-menu-page>
        </p-tabPanel>
    </p-tabView>
</div>
